import React from 'react';
import { string, oneOf, func } from 'prop-types';
import styled, { css } from 'styled-components';
import { C_EBON, C_WHITE, C_POSTBOX } from '@bbc/psammead-styles/colours';
import { GEL_SPACING, GEL_SPACING_TRPL } from '@bbc/gel-foundations/spacings';
import { GEL_MINION } from '@bbc/gel-foundations/typography';
import { getSansBold } from '@bbc/psammead-styles/font-styles';
import { mediaIcons } from '@bbc/psammead-assets/svgs';
import VisuallyHiddenText from '@bbc/psammead-visually-hidden-text';
var GEL_SPACING_DEC = '5rem';
var BGC_TRANSITION_DURATION = '300ms';
var Button = /*#__PURE__*/styled.button.withConfig({
  displayName: "Button",
  componentId: "sc-34e3rb-0"
})(["background-color:", ";border:none;color:", ";cursor:pointer;display:block;", " ", ";height:", ";padding:0;transition:background-color ", ";width:", ";&:hover,&:focus{background-color:", ";transition:background-color ", ";}"], C_EBON, C_WHITE, function (_ref) {
  var service = _ref.service;
  return getSansBold(service);
}, GEL_MINION, GEL_SPACING_DEC, BGC_TRANSITION_DURATION, GEL_SPACING_DEC, C_POSTBOX, BGC_TRANSITION_DURATION);
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-34e3rb-1"
})(["> svg{color:", ";fill:currentColor;height:", ";", " width:", ";}"], C_WHITE, GEL_SPACING_TRPL, function (_ref2) {
  var datetime = _ref2.datetime,
      duration = _ref2.duration,
      durationSpoken = _ref2.durationSpoken;
  return datetime && duration && durationSpoken && css(["margin-top:", ";"], GEL_SPACING);
}, GEL_SPACING_TRPL);
var TimeDuration = /*#__PURE__*/styled.time.withConfig({
  displayName: "TimeDuration",
  componentId: "sc-34e3rb-2"
})(["display:block;margin-top:", ";"], GEL_SPACING);

var PlayButton = function PlayButton(_ref3) {
  var className = _ref3.className,
      datetime = _ref3.datetime,
      duration = _ref3.duration,
      durationSpoken = _ref3.durationSpoken,
      type = _ref3.type,
      service = _ref3.service,
      title = _ref3.title,
      onClick = _ref3.onClick,
      guidanceMessage = _ref3.guidanceMessage;
  var hiddenText = "".concat(guidanceMessage || '', " Play ").concat(type, ", ").concat(datetime && duration && durationSpoken ? "\"".concat(title, "\", ").concat(durationSpoken) : "\"".concat(title, "\""), " ").trim();
  return /*#__PURE__*/React.createElement(Button, {
    className: className,
    service: service,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(VisuallyHiddenText, null, hiddenText), /*#__PURE__*/React.createElement(IconWrapper, {
    datetime: datetime,
    duration: duration,
    durationSpoken: durationSpoken,
    "aria-hidden": "true"
  }, mediaIcons[type]), datetime && duration && durationSpoken && /*#__PURE__*/React.createElement(TimeDuration, {
    dateTime: datetime,
    "aria-hidden": "true"
  }, duration));
};

PlayButton.propTypes = {
  datetime: string,
  duration: string,
  durationSpoken: string,
  type: oneOf(['video', 'audio']),
  title: string.isRequired,
  service: string.isRequired,
  onClick: func.isRequired,
  className: string,
  guidanceMessage: string
};
PlayButton.defaultProps = {
  datetime: null,
  duration: null,
  durationSpoken: null,
  type: 'video',
  className: null,
  guidanceMessage: null
};
export default PlayButton;